import { render, staticRenderFns } from "./FinancialProducts.vue?vue&type=template&id=f52f92e2&scoped=true"
import script from "./FinancialProducts.vue?vue&type=script&lang=js"
export * from "./FinancialProducts.vue?vue&type=script&lang=js"
import style0 from "./FinancialProducts.vue?vue&type=style&index=0&id=f52f92e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52f92e2",
  null
  
)

export default component.exports